import { render, staticRenderFns } from "./ClientEcommerceLayout.vue?vue&type=template&id=c314b25e"
import script from "./ClientEcommerceLayout.vue?vue&type=script&lang=js"
export * from "./ClientEcommerceLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./services.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvar%2Fwww%2Fbackend.limatours.com.pe%2Fresources%2Fjs%2Fpages%2FClients%2FManageClient%2FEcommerce%2FClientEcommerceLayout.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports